import clsx from 'clsx';
import { ReactNode, useState } from 'react';

export interface NavigationTooltipProps {
  text: string;
  children: ReactNode;
  disabled?: boolean;
  isOpen?: boolean;
  disableHover?: boolean;
  className?: string;
}

export function NavigationTooltip(props: NavigationTooltipProps) {
  const {
    text,
    children,
    disabled = false,
    isOpen,
    disableHover = false,
    className,
  } = props;

  const [isHovering, setIsHovering] = useState(false);
  const open = isOpen !== undefined ? isOpen : !disableHover && isHovering;
  if (disabled) {
    return <>{children}</>;
  }
  const showTooltip = () => {
    if (!disableHover) {
      setIsHovering(true);
    }
  };

  const hideTooltip = () => {
    if (!disableHover) {
      setIsHovering(false);
    }
  };

  return (
    <div
      className="relative"
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
    >
      {children}
      {open && (
        <div
          className={clsx(
            'absolute left-full top-1 z-50 ml-1 rounded-lg px-4 py-2 text-sm font-medium shadow-xl drop-shadow-lg',
            'dark:bg-ondark-bg-1 bg-onlight-bg-1 dark:text-ondark-text-1 text-onlight-text-2 dark:ring-ondark-bg-1 ring-onlight-bg-1 ring-1 ring-opacity-10',
            'after:absolute after:right-full after:top-1/2 after:-translate-y-1/2',
            'after:border-r-onlight-bg-3 dark:after:border-r-ondark-bg-3 after:border-8 after:border-transparent',
            'border-onlight-bg-3 dark:border-ondark-bg-3 border',
            className
          )}
        >
          {text}
        </div>
      )}
    </div>
  );
}

export default NavigationTooltip;
